__turbopack_context__.v({
  "replayButton": "BackgroundVideo-module__S8WzIG__replayButton",
  "videoWrapper": "BackgroundVideo-module__S8WzIG__videoWrapper",
});
